import { makeStyles, Typography } from '@material-ui/core';
import { useUrlState } from '@zennya/web-component-library/src';
import isEmpty from 'lodash.isempty';
import { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useTrackEvent } from 'util/trackEvent';
import { bookingState, manualRefreshState, rebookedState } from '../RecoilState';
import { BookingConfirmPopup } from './BookingConfirmPopup';
import { BookingDetail } from './BookingDetail';
import { BookingNotFound } from './BookingNotFound';
import { BookingTimeoutPopup } from './BookingTimeoutPopup';
import { RebookingPopup } from './RebookingPopup';


const useStyles = makeStyles((theme) => {
  return {
    box: {
      // height: 'calc(100vh - 150px)',
    },
    mapBox: {
      height: '100%'
    },
    scrollCard: {
      overflowY: 'auto',
      height: '100%'
    }
  }
})

const BookingDetails = ({ match, location }) => {
  const classes = useStyles()
  const history = useHistory()

  const serviceId = match?.params?.serviceId
  const booking = useRecoilValue(bookingState);
  
  const setManualRefreshState = useSetRecoilState(manualRefreshState);
  const setRebookedState = useSetRecoilState(rebookedState);
  const rebooked = useRecoilValue(rebookedState);

  const trackEvent = useTrackEvent();
  const [medium, setMedium] = useUrlState({
    queryKey: 'medium',
  });

  useMemo(
    () => {
      if (isEmpty(booking)) {
        setManualRefreshState(Math.random())
      }
    }, [booking]
  );
  const renderPopup = useMemo(() => {
    if (rebooked) {
      setRebookedState(false)
      return <RebookingPopup />
    }
    else if (booking?.scheduled_status === 'UNMATCHED') {
      if (booking?.status_v2 === 'timed out') {
        trackEvent('Details - Display Timeout dialog ', { dialog: 'BookingTimeoutPopup' })
        return <BookingTimeoutPopup
          serviceId={serviceId}
          confirmed={((booking?.is_whitelabel && booking?.isConfirmed) || !booking?.is_whitelabel)}
        />
      }
      if (((booking?.is_whitelabel && booking?.isConfirmed))) {
        trackEvent('Details - Display Unmatched dialog ', { dialog: 'BookingConfirmPopup' })
        return <BookingConfirmPopup booking_id={serviceId} />
      }
    }

  }, [booking?.is_confirmed, booking?.scheduled_status, booking?.status, rebooked, serviceId, setRebookedState]);



  useEffect(() => {
    const track = async () => {
      await trackEvent('Viewed Booking Details', {})
    }
    if (serviceId && !isEmpty(booking)) {
      track()
    }
  }, []);
  if (!serviceId) {
    return <BookingNotFound />
  }

  if (isEmpty(booking)) {
    return <Typography>Loading...</Typography>
  }
  return (
    <div className={classes.box}>
      {renderPopup}
      <BookingDetail
        booking={booking}
        onRefreshContent={() => {
          setManualRefreshState(Math.random())
        }}
        fromMap={location?.state?.from === 'map'} />
    </div>

  )
}

export { BookingDetails };

